import React, { useState } from "react";
import "../styles.css";
import logo from "../assets/logo.png";

function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [cargando, setCargando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setCargando(true);
    try {
      await onLogin(username, password);
    } catch (err) {
      setError(err.message || "Error al iniciar sesión");
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <img
            src={logo}
            alt="Logo"
            className="login-logo"
          />
          <h2>Gestor de Mantenimientos</h2>
          <p>Inicia sesión para continuar</p>
        </div>
 
        {error && <div className="login-error-message">{error}</div>}
 
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Usuario</label>
            <input
              id="username"
              type="text"
              value={username}
              autoComplete="username"
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Introduce tu usuario"
              disabled={cargando}
              required
            />
          </div>
 
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              value={password}
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Introduce tu contraseña"
              disabled={cargando}
              required
            />
          </div>
 
          <button 
            type="submit" 
            className="btn-login"
            disabled={cargando || !username || !password}
          >
            {cargando ? (
              <span className="spinner-small"></span>
            ) : "Iniciar sesión"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
